import { render, staticRenderFns } from "./DescomplicaLogo.vue?vue&type=template&id=5985f756&scoped=true&"
import script from "./DescomplicaLogo.vue?vue&type=script&lang=ts&"
export * from "./DescomplicaLogo.vue?vue&type=script&lang=ts&"
import style0 from "./DescomplicaLogo.vue?vue&type=style&index=0&id=5985f756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985f756",
  null
  
)

export default component.exports